(() => {
  'use strict';
  if (location.pathname !== '/ru/pages/auswahl' || window.FrostixCuratedReviewLinks) return;
  window.FrostixCuratedReviewLinks = true;
  const root = document.querySelector('main');
  if (!root) return;
  const selector = '.jdgm-carousel-wrapper a[href]';
  function localize(anchor) {
    if (!anchor.matches(selector)) return;
    const href = anchor.getAttribute('href');
    const url = new URL(href, location.origin);
    if (url.origin !== location.origin || !url.pathname.startsWith('/products/')) return;
    anchor.setAttribute('href', '/ru' + url.pathname + url.search + url.hash);
  }
  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) localize(node);
    node.querySelectorAll(selector).forEach(localize);
  }
  scan(root);
  // Judge.me can re-render or replace its carousel after initial page load.
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') localize(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
})();
